module.exports = __webpack_public_path__ + "static/media/circle_indigo.4ae0ab90.svg";